// @ts-nocheck
import React from 'react';
import { Box, Typography, Paper, useTheme, alpha } from '@mui/material';
import PropTypes from 'prop-types';
const ruleDefaultValue = { styles: {} };
const RulePreview = ({ rule = ruleDefaultValue }) => {
  const theme = useTheme();

  return (
    <Box sx={{ mt: 1, width: '100%' }}>
      <Typography variant="body1" color="textSecondary">
        Preview:
      </Typography>
      <Paper
        sx={{
          mt: 0.5,
          p: 1,
          ...rule.styles,
          border: `1px solid ${alpha(theme?.palette?.primary?.main, 0.1)}`,
        }}
      >
        Sample Text
      </Paper>
    </Box>
  );
};

RulePreview.propTypes = {
  rule: PropTypes.shape({
    styles: PropTypes.shape({}),
  }),
};

export default RulePreview;
